export default __webpack_public_path__ + "static/media/card.ee20fa7f.svg";